import { render, staticRenderFns } from "./ListAssociados.vue?vue&type=template&id=0c1053d4&scoped=true"
import script from "./ListAssociados.vue?vue&type=script&lang=js"
export * from "./ListAssociados.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/listCard.css?vue&type=style&index=0&id=0c1053d4&prod&scoped=true&lang=css&external"
import style1 from "./ListAssociados.vue?vue&type=style&index=1&id=0c1053d4&prod&lang=scss"
import style2 from "./ListAssociados.vue?vue&type=style&index=2&id=0c1053d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1053d4",
  null
  
)

export default component.exports